import uiCopy from "../../../copy/en/documents-navigation.json" with { type: "json" };
import type { BundleSummary } from "../../lib/types.js";

export const DOCUMENTS_PATH = "/documents";
export const SUBMISSIONS_PATH = `${DOCUMENTS_PATH}/submissions`;
export const ONBOARDING_PATH = `${DOCUMENTS_PATH}/onboarding`;
export const REP_AGREEMENTS_PATH = `${DOCUMENTS_PATH}/rep-agreements`;

export function legacyAdminDocumentsPath(search: string): string {
  const params = new URLSearchParams(search);
  params.set("section", "representatives");
  if (!params.has("status")) params.set("status", "outstanding");
  return `${DOCUMENTS_PATH}?${params}`;
}

function withReturn(path: string, returnTo?: string): string {
  return returnTo ? `${path}?${new URLSearchParams({ returnTo })}` : path;
}

export function submissionPath(id: string, returnTo?: string): string {
  return withReturn(`${SUBMISSIONS_PATH}/${encodeURIComponent(id)}`, returnTo);
}

export function bundlePath(id: string, returnTo?: string): string {
  return withReturn(`${ONBOARDING_PATH}/${encodeURIComponent(id)}`, returnTo);
}

/** Only established internal workspaces can become a breadcrumb destination. */
export function documentReturnTarget(search: string, fallback = SUBMISSIONS_PATH): { to: string; label: string } {
  const raw = new URLSearchParams(search).get("returnTo");
  if (raw && raw.startsWith("/") && !raw.startsWith("//") && !raw.includes("\\")) {
    const path = raw.split(/[?#]/, 1)[0];
    if (path === SUBMISSIONS_PATH) return { to: raw, label: uiCopy.documentReturnTarget.submissions };
    if (path === ONBOARDING_PATH) return { to: raw, label: uiCopy.documentReturnTarget.onboarding };
    if (/^\/practices\/[a-zA-Z0-9_-]+$/.test(path)) return { to: raw, label: uiCopy.documentReturnTarget.practice };
  }
  return { to: fallback, label: fallback === ONBOARDING_PATH ? uiCopy.documentReturnTarget.onboarding : uiCopy.documentReturnTarget.submissions };
}

/** Portal-internal drill-down: 1-form → submission detail; multi-form → bundle page. */
export function onboardingHref(b: BundleSummary, returnTo?: string): string {
  if (b.members.length === 1) return submissionPath(b.members[0].submissionId, returnTo);
  if (b.implicit) return submissionPath(b.id, returnTo);
  return bundlePath(b.id, returnTo);
}
